import Environment from '../common/Environment';
import Board from '../entities/Board';
import Member from '../entities/Member';
import BoardJson from '../jsons/BoardJson';

export default class DeleteBoard {
  execute(board: Board, account: Member): Promise<void> {
    const method: string = 'DELETE';
    const path = Environment.server() + '/board/' + board.id;

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account
        })
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: BoardJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve();
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/DeleteBoard.ts